/**
 * Created by Administrador on 05/11/2024.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('takeoffCapacityService', takeoffCapacityService);

    takeoffCapacityService.$inject = ['$http', 'CONFIG', 'messageService'];


    function takeoffCapacityService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/report-level-of-sales-flight';
        var urlFlightBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/flights/takeoffCapacity' ;

        var service = {
            getTakeoffCapacityByFlightNumber: getTakeoffCapacityByFlightNumber,
            updateTakeoffCapacity: updateTakeoffCapacity
            /*deletePnrReserve: deletePnrReserve*/
        };

        return service;

        function getTakeoffCapacityByFlightNumber(flightId){
            return $http.get(urlBase +"/takeoff-capacity/" +flightId )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function updateTakeoffCapacity(flightId, flight){
            return $http.put(urlFlightBase + "/" + flightId, flight)
                .then(function(response){
                    messageService.registerUpdate('');
                    return "ok";
                })
                .catch(function(){
                    messageService.registerUpdateError('');
                    return "error";
                });
        }

        /*function deletePnrReserve(codePnr, userLogin){
            return $http.put(urlBase + "/cancel/" + codePnr +"?isSold=false&isAdminAirline=true&user_login=" + userLogin)
                .then(function(response){
                    messageService.registerDelete('manageReservations');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('manageReservations');
                });
        }*/
    }
})();
